import React from "react";
import styles from "./styles/OutputWindowInfo.module.css";
/**
 * Info output window component
 * Used in ticket info section in the search page
 */
const OutputWindowInfo = ({ exKey, header, body }) => {
    return (
        <div className={`${styles.main_info_container}`}>
            <div className={`${styles.info_container}`}>
                <h3
                    className={`
                      
                        ${styles.info_header}`}
                >
                    {header}
                </h3>

                <div className={`${styles.info_body} `}>
                    {body?.map((offence, idx) => (
                        <p
                            key={`${exKey}${idx}${
                                offence?.text &&
                                typeof offence?.text === "string"
                                    ? offence?.text?.toLowerCase()
                                    : offence && typeof offence === "string"
                                    ? offence?.toLowerCase()
                                    : ""
                            }`}
                        >
                            {
                                // offence?.text
                                //     ? offence?.text?.toLowerCase()
                                //     : offence?.toLowerCase()
                                offence?.text &&
                                typeof offence?.text === "string"
                                    ? offence?.text?.toLowerCase()
                                    : offence && typeof offence === "string"
                                    ? offence?.toLowerCase()
                                    : ""
                            }
                        </p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default OutputWindowInfo;
